import { render, staticRenderFns } from "./AutoCompleteInputComponent.vue?vue&type=template&id=45a8a1aa&"
import script from "./AutoCompleteInputComponent.vue?vue&type=script&lang=ts&"
export * from "./AutoCompleteInputComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a8a1aa')) {
      api.createRecord('45a8a1aa', component.options)
    } else {
      api.reload('45a8a1aa', component.options)
    }
    module.hot.accept("./AutoCompleteInputComponent.vue?vue&type=template&id=45a8a1aa&", function () {
      api.rerender('45a8a1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AutoCompleteInputComponent.vue"
export default component.exports